// components
import '../ui/emergencyPopup.css';
import { Modal } from 'react-async-popup';
import { ConfirmQuoteEditionAfterAcceptanceModal } from './confirmQuoteEditionAfterAcceptanceModal';

const useConfirmQuoteEditionAfterAcceptance = (ticket, quote) => {
  const confirmQuoteEditionAfterAcceptanceModal = async (changes) => {
    const props = { ticket, quote, changes };

    const { show } = await Modal.new({
      content: <ConfirmQuoteEditionAfterAcceptanceModal props={props} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openConfirmQuoteEditionAfterAcceptanceModal = async (changes) => {
    const result = await confirmQuoteEditionAfterAcceptanceModal(changes);
    if (result) {
      return result;
    }
  };

  return {
    openConfirmQuoteEditionAfterAcceptanceModal,
  };
};

export default useConfirmQuoteEditionAfterAcceptance;
